
import { defineComponent } from "vue";

export default defineComponent({
  name: "kt-results",
  components: {},
});
